import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const LogoImg = styled.img`
  width: 100%;
  max-width: 225px;

  ${({ alignMiddle }) =>
    alignMiddle &&
    `
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  `}
`

const map = {
  1: 'png',
  4: 'svg',
  7: 'png',
  8: 'png',
  9: 'png',
  11: 'png',
  12: 'png',
  13: 'png',
  16: 'png',
  2: 'svg',
  3: 'svg',
  5: 'svg',
  6: 'svg',
  14: 'svg',
  15: 'svg',
  40: 'svg',
  50: 'svg',
  60: 'svg',
  80: 'png'
}

const getPartnerLogo = partnerId => {
  return require(`../images/${partnerId}.${map[partnerId]}`)
}

const PartnerLogo = ({ partnerId, partnerName, alignMiddle }) => {
  if (!partnerId) {
    return partnerName || '-'
  }

  return (
    <>
      {!map[partnerId] ? (
        partnerName
      ) : (
        <LogoImg alignMiddle={alignMiddle} src={getPartnerLogo(partnerId)} alt={partnerName} />
      )}
    </>
  )
}

PartnerLogo.propTypes = {
  partnerId: PropTypes.number,
  partnerName: PropTypes.string,
  alignMiddle: PropTypes.bool.isRequired
}

PartnerLogo.defaultProps = {
  alignMiddle: false
}

export default PartnerLogo
